<template>
  <div class="row pl-3 pb-3 pr-3 pt-1 mr">
    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Nombre del Asistente:
      </div>
      <div class="regular" v-text="item?.assistantName?.name || '-'" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Tipo del Asistente:
      </div>
      <div class="regular" v-text="item?.resourceType?.name || '-'" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Cantidad de Horas:
      </div>
      <div class="regular" v-text="item?.dailyShift?.name || '-'" />
    </div>

    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'AssistantInformationItem',
  props: {
    item: { type: Object, default: null },
    submitted: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped></style>
